import { render, staticRenderFns } from "./UpdateNotification.vue?vue&type=template&id=5f043877"
import script from "./UpdateNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateNotification.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports